import { Grid, Typography } from '@mui/material';

const SearchPanel = ({ title, header, image, children, gap }) => {
  return (
    <Grid
      container
      direction="column"
      sx={{
        backgroundColor: '#E2E2E2',
        justifyContent: 'center',
      }}
    >
      {/* Sección con fondo */}
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          minHeight: '300px',
          backgroundImage: image ? `url(${image})` : 'none',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          paddingBottom: { xs: '30px' },
          paddingTop: { xs: '30px' },
          px: { xs: 0, md: 4, lg: 7 },
          py: { xs: 0, md: 5 },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {/* Contenedor blanco */}
          <Grid
            container
            justifyContent="center"
            sx={{
              mt: '40px',
              mb: '40px',
              px: {
                xs: 0,
                sm: '45px',
                md: '70px',
              },
            }}
          >
            <Grid
              container
              sx={{
                padding: { xs: '16px', md: '30px' },
                borderRadius: { xs: '8px', md: '15px' },
                backgroundColor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                gap: gap ?? { xs: 3, md: 2 },
              }}
            >
              {/* Título fijo arriba */}
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '1.2rem',
                  color: '#000',
                  textAlign: 'left',
                  marginBottom: header ? { xs: '-4px', md: '-20px' } : 'auto',
                }}
              >
                {title}
              </Typography>

              {/* Header opcional debajo del título */}
              {header && header}

              {/* Contenido dinámico */}
              {children}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SearchPanel;
